// extracted by mini-css-extract-plugin
export default {"container":"ProfessorList_container__knu61","container__table":"ProfessorList_container__table__uz3Dd","container__buttons":"ProfessorList_container__buttons__nrDkt"};